/**
 * 骑手状态变更弹框
 */
import React from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import styles from './StateUpdateModal.module.scss';
import { XTextArea, XInputNum } from '@/components/xqxc_ui';
import { message } from 'antd';
import http from '@/assets/api/http';

class StateUpdateModal extends React.Component {

    state = {
        confirmLoading: false,
        reason: '', // 封禁原因
        disableDay: '', // 封禁天数
    }

    _handleOk = () => {
        const { data } = this.props;
        const { disableDay, reason } = this.state;
        const userId = data.userId; // 骑手ID
        if (!this._isHaveValue(disableDay)) {
            message.warning('请输入禁用天数');
        } else if (!this._isHaveValue(reason)) {
            message.warning('请输入禁用原因');
        } else {
            http('/?cmd=com.xqxc.api.pig.mis.biz.account.UserAccountMisService.updateUserBrokerStatus', { userId, status: 'DISABLE', disableDay, reason }, 'POST').then(() => {
                message.success('禁用成功');
                this.props.closeModal(true);
            }).catch((e) => {
                message.error(e.message);
            });
        }
    }

    // 检查是否有输入数字
    _isHaveValue = (val) => {
        if (val === '' || val === null || val === undefined) {
            return false;
        } else {
            return true;
        }
    }

    _handleCancel = () => {
        this.props.closeModal();
    }

    render() {
        const { confirmLoading, reason, disableDay } = this.state;

        return (
            <Modal
                width={600}
                centered
                title='禁用'
                visible={true}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.container}>
                    <XInputNum
                        style={{ marginTop: '10px' }}
                        label='禁用天数'
                        placeholder='请输入天数'
                        value={disableDay}
                        bindThis={this}
                        bindName='disableDay'
                        precision={0}
                        suffix='天'
                        min={0}
                        max={999}
                        isRequired={true}
                    />
                    <XTextArea
                        style={{ marginTop: '10px' }}
                        inputStyle={{ width: '360px', resize: 'none' }}
                        label='禁用原因'
                        placeholder='请输入禁用原因'
                        value={reason}
                        bindThis={this}
                        bindName='reason'
                        maxLength='200'
                        showLength={true}
                        isRequired={true}
                    />
                </div>
            </Modal>
        );
    }
}

StateUpdateModal.propTypes = {
    data: PropTypes.object, // 弹窗传递参数
    closeModal: PropTypes.func.isRequired, // 关闭弹框的回调函数
};

export default StateUpdateModal;